import { ModalHardwareInstallBusinessUnitSelectActions } from "./modal-hardware-install-business-unit-select";
import { ModalHardwareInstallBusinessUnitCreateActions } from "./modal-hardware-install-business-unit-create";
import { ModalHardwareInstallCRBrandSelectActions } from "./modal-hardware-install-cr-brand-select";
import { MModalHardwareInstallFinishActions } from "./modal-hardware-install-finish";
import { useContextModalHardwareInstall } from "../context/modal-hardware-install-context";

export const ModalHardwareInstallFooter = () => {
  const { currentPageId } = useContextModalHardwareInstall();
  return (
    <>
      {currentPageId === "business-unit-select" && (
        <ModalHardwareInstallBusinessUnitSelectActions />
      )}
      {currentPageId === "business-unit-create" && (
        <ModalHardwareInstallBusinessUnitCreateActions />
      )}
      {currentPageId === "cr-select" && (
        <ModalHardwareInstallCRBrandSelectActions />
      )}
      {currentPageId === "finish" && <MModalHardwareInstallFinishActions />}
    </>
  );
};
